import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as ArrowRightIcon } from "feather-icons/dist/icons/arrow-right.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-7.svg";

import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { getLatestPosts } from "../data/posts";
import { BLOG_DESCRIPTION } from "../config";
import PostCard from "./PostCard";
import { HighlightedText, Eyebrow, PrimaryButtonLink } from "./ui";

/**
 * Section « Derniers articles » réutilisable (page d'accueil, à propos…).
 * Affiche les `count` articles les plus récents en cartes, puis un bouton vers /blog.
 */

const HeadingContainer = tw.div`text-center`;
const Subheading = tw(Eyebrow)`block mb-3`;
const Heading = tw(SectionHeading)``;
const Description = tw(SectionDescription)`mx-auto text-center`;

const Grid = tw.div`mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3`;
const ButtonRow = tw.div`mt-12 flex justify-center`;
const Button = styled(PrimaryButtonLink)`
  ${tw`inline-flex items-center px-10 py-4`}
  svg {
    ${tw`w-4 h-4 ml-2`}
  }
`;

const DecoratorBlob1 = tw(SvgDecoratorBlob1)`pointer-events-none -z-10 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`;
const DecoratorBlob2 = tw(SvgDecoratorBlob2)`pointer-events-none -z-10 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-primary-500`;

export default function LatestPosts({
  subheading = "Le blog",
  heading = (
    <>
      Les nouveautés tech à <HighlightedText>Besançon.</HighlightedText>
    </>
  ),
  description = BLOG_DESCRIPTION,
  count = 3,
  buttonText = "Voir tous les articles",
}) {
  const posts = getLatestPosts(count);
  if (!posts.length) return null;

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        </HeadingContainer>
        <Grid>
          {posts.map(post => (
            <PostCard key={post.slug} post={post} />
          ))}
        </Grid>
        <ButtonRow>
          <Button to="/blog">
            {buttonText} <ArrowRightIcon aria-hidden="true" />
          </Button>
        </ButtonRow>
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
}
